import React from 'react';
import { Eye, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Always-visible bar shown while an admin is acting as a managed company.
 * Rendered globally (above the app) so it persists across the company UI,
 * which hides the normal nav. One-click Exit restores the admin session.
 */
export default function ImpersonationBanner() {
  const { impersonation, exitImpersonation } = useAuth();
  if (!impersonation) return null;

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 2000,
        background: '#854f0b',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        padding: '8px 16px',
        fontSize: 14,
        lineHeight: 1.3,
      }}
      role="status"
    >
      <span
        style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}
      >
        <Eye size={16} aria-hidden="true" />
        <span>
          Acting as <strong>{impersonation.name}</strong>. Changes are made on
          their behalf and are audit logged.
        </span>
      </span>
      <button
        type="button"
        onClick={exitImpersonation}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          background: '#fff',
          color: '#854f0b',
          border: 'none',
          borderRadius: 6,
          padding: '4px 12px',
          fontSize: 13,
          fontWeight: 600,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        <LogOut size={14} aria-hidden="true" /> Exit
      </button>
    </div>
  );
}
